import React from 'react';
import classnames from 'classnames';
import { useDuperbrowseViewType } from '../../../Duperbrowse/DuperbrowseViewContext';
import s from './CentralColumn.scss';
var CentralColumn = function (_a) {
    var className = _a.className, children = _a.children, supportSidebar = _a.supportSidebar;
    var isLightbox = useDuperbrowseViewType().isLightbox;
    return (React.createElement("div", { className: classnames(s['root'], supportSidebar && s['sidebar'], isLightbox && s['lightbox'], className) }, children));
};
CentralColumn.displayName = 'CentralColumn';
export default CentralColumn;
//# sourceMappingURL=CentralColumn.js.map